import { createInjectable } from '@shared/utils/dependency';

export const NoneBusinessDependency = createInjectable({
	emitLogin(_userId: { userId: string }) {},
	stopAccountDelete() {},
	trackUserRegister(params: Record<string, any>) {},
});
